import { createFileRoute } from '@tanstack/react-router';
import { AccessControlPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/access-control')({
  component: AccessControlPage,
});
